import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "../../../auth/authRoles";

const DtJudgementTable = Loadable(lazy(() => import("../caseLaw/App")));
const StatutesTable = Loadable(lazy(() => import("../statutes/App")));
const ActsTable = Loadable(lazy(() => import("../acts/App")));
const RulesTable = Loadable(lazy(() => import("../rules/App")));

const directTaxRoutes = [
  { path: "/st/judgements", element: <DtJudgementTable />, auth: authRoles.guest},
  { path: "/st/judgements/:id/*", element: <DtJudgementTable />, auth: authRoles.guest },
  { path: "/st/statutes", element: <StatutesTable />, auth: authRoles.guest},
  { path: "/st/statutes/:id/*", element: <StatutesTable />, auth: authRoles.guest },
  { path: "/st/acts", element: <ActsTable />, auth: authRoles.guest},
  { path: "/st/acts/:id/*", element: <ActsTable />, auth: authRoles.guest },
  { path: "/st/rules", element: <RulesTable />, auth: authRoles.guest},
  { path: "/st/rules/:id/*", element: <RulesTable />, auth: authRoles.guest },
];

export default directTaxRoutes;
